import { isEqual } from "lodash";
import { DependencyList, EffectCallback, useEffect, useRef } from "react";

export function useDeepEffect(
  effectFunc: EffectCallback,
  deps: DependencyList
) {
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);

  useEffect(() => {
    const isSame = prevDeps.current.every((o, i) => isEqual(o, deps[i]));
    let cleanup;
    if (isFirst.current || !isSame) {
      cleanup = effectFunc();
    }

    isFirst.current = false;
    prevDeps.current = deps;

    return cleanup;
  }, deps);
}
